import { render, staticRenderFns } from "./PartnershipH.vue?vue&type=template&id=891e8156"
import script from "./PartnershipH.vue?vue&type=script&lang=js"
export * from "./PartnershipH.vue?vue&type=script&lang=js"
import style0 from "./PartnershipH.vue?vue&type=style&index=0&id=891e8156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports